export default "__VITE_ASSET__BR7DUcB3__"